import React, { useState } from 'react';
import BalanceCard    from '../components/wallet/BalanceCard';
import TopUpModal     from '../components/wallet/TopUpModal';
import TransactionList from '../components/wallet/TransactionList';
import { useWallet }  from '../hooks/useWallet';

const WalletPage = () => {
  const [showTopUp, setShowTopUp] = useState(false);
  const { data, isLoading } = useWallet();

  const wallet       = data?.wallet       ?? null;
  const transactions = data?.transactions ?? [];

  return (
    <div className="page-scroll">
      <div className="pb-8">

        {/* Balance card */}
        <BalanceCard
          balance={wallet?.balance}
          currency={wallet?.currency ?? 'GHS'}
          onTopUp={() => setShowTopUp(true)}
          isLoading={isLoading}
        />

        {/* Section header */}
        <div className="px-5 mt-6 mb-2 flex items-center justify-between animate-fadeUp">
          <h2 className="font-syne font-bold text-slate-800 text-base">Transaction History</h2>
          {transactions.length > 0 && (
            <span className="font-dm text-xs text-surface-300">{transactions.length} records</span>
          )}
        </div>

        {/* Transaction list */}
        <TransactionList transactions={transactions} isLoading={isLoading} />

      </div>

      {/* Top-up modal */}
      {showTopUp && (
        <TopUpModal onClose={() => setShowTopUp(false)} />
      )}
    </div>
  );
};

export default WalletPage;
